import OperationTypeIcon from "./OperationTypeIcon";
import { Dispatch, ReactNode, SetStateAction } from "react";
import CaretDownIcon from "@/lib/CaretDownIcon";
import { components } from "@/lib/ApiSchema";

export default function OperationHeader({
  type,
  name,
  expand,
  setExpand,
  children,
}: {
  type: components["schemas"]["CalculatorTypeEnum"];
  name: string;
  expand?: boolean;
  setExpand?: Dispatch<SetStateAction<boolean>>;
  children?: ReactNode;
}) {
  return (
    <div className="w-full flex justify-between items-start">
      <div className="flex gap-2 items-center" data-operation-type={type}>
        <OperationTypeIcon operationType={type} className="size-4" />
        <div className="font-bold text-sm">{name}</div>
      </div>
      <div className="flex items-center gap-2">
        {children}
        {setExpand && (
          <div className="cursor-pointer" onClick={() => setExpand(!expand)}>
            <CaretDownIcon expanded={!!expand} />
          </div>
        )}
      </div>
    </div>
  );
}
